import { Injectable } from "@angular/core";
import { SegmentService } from "@main-services/segment.service";
import { RudderstackService } from "@main-services/rudderstack.service";

@Injectable()
export class MultipleWalletsTrackingService {
	constructor(
		private segmentService: SegmentService,
		private rudderstackService: RudderstackService
	) {}

	public trackMultipleWalletScreenViewed(): void {
		this.segmentService.track({ name: "Deposit Crypto Multi Wallet Modal Viewed" });
		this.rudderstackService.track({ name: "Deposit Crypto Multi Wallet Modal Viewed" });
	}

	public trackMultipleWalletClicked(): void {
		this.segmentService.track({ name: "Deposit Crypto Multi Wallet Modal Clicked" });
		this.rudderstackService.track({ name: "Deposit Crypto Multi Wallet Modal Clicked" });
	}
}
